
import { HeadingWithParagraph } from '@/types/HeadingWithParagraph'
import React from 'react'
import Image from 'next/image';


export const HeadingWithParagraphs = ({
    content
}: {
    content: HeadingWithParagraph;
}) => {

    return (
        <div>
            <h3 className=' body-xl-bold mt-[28px]' >{content.heading}</h3>
            {
                content.image &&
                <Image className='mt-3' src={content.image} alt={content.image_alt} width={640} height={450} />
            }
            <div className='flex flex-col gap-3 mt-3' >
                {content.paragraphs.map((paragraph, index) => (
                    <div className='body-reg' key={index}>{paragraph}</div>
                ))}
            </div>
        </div>
    )
}